import { MoreHorizOutlined as MoreHorizOutlinedIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useCallback } from 'react';

import { useMenuContext } from 'pages/ParentHelper/components/History/hooks';
import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { ListItemText } from 'shared/components/ListItem';
import { useFormatDateWithTimezone } from 'shared/hooks/dates';
import { formatDate } from 'shared/utils/date';

import { ActionButton } from './components/ActionButton';
import { Wrapper } from './components/Wrapper';
import { ACTION_BUTTON_CLASSNAME } from './constants';
import { useChatTopicStyles, useWrapperClick } from './hooks';

import type { Topic } from 'pages/ParentHelper/types';
import type { FC, MouseEvent } from 'react';

interface ChatTopicProps
  extends Pick<Topic, 'chatId' | 'topic' | 'lastUpdatedDate'> {
  loadMoreRef?: (element: HTMLElement | null) => void;
}

export const ChatTopic: FC<ChatTopicProps> = ({
  topic,
  lastUpdatedDate,
  chatId,
  loadMoreRef,
}) => {
  const { isLoadingAnswer, deletedChatId } = useParentHelperContext();
  const { onOpen } = useMenuContext();

  const formatDateWithTimeZone = useFormatDateWithTimezone(formatDate);
  const chatTopicStyles = useChatTopicStyles(chatId);

  const onWrapperClick = useWrapperClick(chatId);

  const openMenu = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      onOpen(e);
    },
    [onOpen],
  );

  return (
    <Wrapper
      sx={chatTopicStyles}
      onClick={onWrapperClick}
      disabled={isLoadingAnswer}
    >
      <ListItemText ref={loadMoreRef}>
        <Typography noWrap>{topic}</Typography>
        <Typography variant="body2" color="text.secondary">
          {formatDateWithTimeZone(new Date(lastUpdatedDate))}
        </Typography>
      </ListItemText>
      {chatId && !deletedChatId && (
        <ActionButton
          id={chatId}
          onClick={openMenu}
          className={ACTION_BUTTON_CLASSNAME}
        >
          <MoreHorizOutlinedIcon />
        </ActionButton>
      )}
    </Wrapper>
  );
};
